export enum SsoErrorPage {
  OAUTH = "oauth",
}
